import { css } from '@emotion/core';
import Menu from '@veeva/corgix/menu';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '../../services/breakpoints';
import OverlayContext from '../../containers/OverlayContext';

function SearchBoxMenuWithRef(
    {
        children,
        className,
        inputContainerRef,
        focusedNodeKeyValue,
        setFocusedNodeKeyValue,
        onSearchItemSelected,
        selectedValue,
        searchText,
        setShowSearchResults,
        setSearchParams,
    },
    ref,
) {
    const { setOverlay } = useContext(OverlayContext);
    const shouldUseMobileSearchOverlay = useMediaQuery({ maxWidth: BREAKPOINTS.EXTRA_SMALL.max });
    const handleMenuMapUpdate = (menuMap) => {
        if (focusedNodeKeyValue !== undefined && !menuMap.hasValue(focusedNodeKeyValue)) {
            // If we had a focus item and it's no longer available, set it to the first node
            setFocusedNodeKeyValue(menuMap.getFirstNode().keyValue);
        }
        // eslint-disable-next-line no-param-reassign
        ref.current = menuMap;
    };

    const handleMenuItemSelected = (_, value) => {
        if (value !== 'not-found') {
            onSearchItemSelected(value);
            setShowSearchResults(false);
            setSearchParams('');
        }
        if (shouldUseMobileSearchOverlay) {
            setOverlay(null);
        }
    };

    return (
        <Menu
            css={
                className ??
                css`
                    width: ${inputContainerRef.current
                        ? inputContainerRef.current.clientWidth
                        : 0}px;
                `
            }
            key={searchText}
            focusedKeyValue={focusedNodeKeyValue}
            onClick={handleMenuItemSelected}
            onMenuMapUpdate={handleMenuMapUpdate}
            selectedValue={selectedValue}
        >
            {children}
        </Menu>
    );
}

const SearchBoxMenu = React.forwardRef(SearchBoxMenuWithRef);

SearchBoxMenuWithRef.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    focusedNodeKeyValue: PropTypes.string,
    inputContainerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    onSearchItemSelected: PropTypes.func,
    searchText: PropTypes.string,
    selectedValue: PropTypes.string,
    setFocusedNodeKeyValue: PropTypes.func,
    setSearchParams: PropTypes.func,
    setShowSearchResults: PropTypes.func,
};
export default SearchBoxMenu;
